module.exports = __webpack_public_path__ + "img/joinus-1.bc87eb83.png";